import React, { ReactNode } from 'react';
import { Flex, Skeleton, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

// TODO: Bad practice. Revalidate layouts
// eslint-disable-next-line boundaries/element-types
import { getDefaultRedirectPath } from 'entities/session';
import { BackButton } from 'shared/ui/BackButton';
import { Breadcrumb, IBreadcrumbItem } from 'shared/ui/Breadcrumb';
import { LinkButton } from 'shared/ui/LinkButton';

import styles from './ListPageLayout.module.scss';

export type ListPageLayoutProps = {
  title: string;
  breadcrumb: IBreadcrumbItem[];
  isBreadcrumbLoading?: boolean;
  createButtonText?: string;
  createPath?: (...rest: string[]) => string;
  children: ReactNode;
  hideCreateButton?: boolean;
  checkBoxMenu?: ReactNode;
};

const ListPageLayout: React.FC<ListPageLayoutProps> = (props) => {
  const {
    children,
    title,
    breadcrumb,
    isBreadcrumbLoading = false,
    createButtonText,
    hideCreateButton,
    createPath,
    checkBoxMenu,
  } = props;

  const navigate = useNavigate();

  const navigateBreadcrumbBack = (): void => {
    const breadcrumbLength = breadcrumb.length;
    if (breadcrumbLength === 1) {
      navigate(getDefaultRedirectPath());
      return;
    }
    navigate(breadcrumb[breadcrumbLength - 2].path as string);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Flex justify="space-between">
          <Flex gap={8}>
            <BackButton onClick={navigateBreadcrumbBack} isDisabled={isBreadcrumbLoading} />
            <Typography.Title level={3}>{title}</Typography.Title>
          </Flex>

          {!hideCreateButton && createPath && (
            <LinkButton linkProps={{ to: createPath() }} buttonProps={{ type: 'primary' }} data-testid="create-button">
              {createButtonText}
            </LinkButton>
          )}
        </Flex>

        <Skeleton
          active
          paragraph={{ rows: 0 }}
          title={{ width: 320 }}
          className={styles.breadcrumbSkeleton}
          loading={isBreadcrumbLoading}
        >
          <div className={styles.breadcrumbWrapper}>
            <Breadcrumb items={breadcrumb} />
          </div>
        </Skeleton>
      </div>
      {checkBoxMenu}
      <div className={styles.children}>{children}</div>
    </div>
  );
};

export default ListPageLayout;
